/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterResultService {
  private filterDataStore: { [id: string]: FilterData } = {};
  private resultDataStore:{ [id: string]: ResultsData } = {};
  private graphDataStore: { [id: string]: GraphData } = {};

  setFilterData(id: string, data:FilterData) {
    this.filterDataStore[id] = { ...data };
  }
  getFilterData(id:string) {
    return this.filterDataStore[id];
  }
  clearFilterData(){
    this.filterDataStore={}
  }
  setGraphData(id: string, data: GraphData) {
    this.graphDataStore[id] = { ...data };
  }
  getGraphData(id:string) {
    return this.graphDataStore[id];
  }
  clearGraphData(){
    this.graphDataStore={}
  }
  storeOriginalResults(id:string , data:ResultsData){
    this.resultDataStore[id] = { ...data };
  }
  getOriginalResults(id: string): any[] | undefined {
    return  this.resultDataStore[id]?.results ?
      [... this.resultDataStore[id].results] : undefined;
  }
  clearResultData(){
    this.resultDataStore={}
  }
}

interface FilterData {
  resultIndex: any;
  data:any;
}
interface ResultsData {
  results:any[];
}
interface GraphData {
  resultIndex: any;
  chart: any;
  graphDatasets: any[];
}

